import { Component, OnInit, Inject , AfterViewInit , ElementRef, OnDestroy,  } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsService } from '@services/analytics.service';


@Component({
  selector: 'smione-error-modal',
  templateUrl: './error-modal.component.html',
  styleUrls: ['./error-modal.component.scss']
})
export class ErrorModalComponent implements OnInit , AfterViewInit, OnDestroy {
  txtFailure :string;
  componentName : string = 'ErrorModal';
    private escapeListener = (e: KeyboardEvent) => {
    if (e.key === 'Escape') {
      e.preventDefault();
      e.stopPropagation();
      this.close();
    }
  };

  constructor(
    public dialogRef: MatDialogRef<ErrorModalComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private translate: TranslateService,
    private analyticsService: AnalyticsService,
    private router: Router,
    private elementRef: ElementRef
    
  ) {}

  ngOnInit() {
    if(!this.dialogData.message){
      this.translate.get('DASHBOARD.MYCARD.UnableToProcessTheRequest').subscribe((data) => { 
        this.txtFailure = data; 
      });
    }
  }

    ngOnDestroy() {
    document.removeEventListener('keydown', this.escapeListener, true);
  }

  ngAfterViewInit() {
    this.dialogRef.afterOpened().subscribe(() => {
      const dialogContainer = this.elementRef.nativeElement.closest('.mat-dialog-container');
      if (dialogContainer) {
        dialogContainer.setAttribute('aria-label', 'Error dialog');
      }
    });

    setTimeout(() => {
      const dialogContainer = this.elementRef.nativeElement.closest('.mat-dialog-container');
      if (dialogContainer && !dialogContainer.getAttribute('aria-label')) {
        dialogContainer.setAttribute('aria-label', 'Error dialog');
      }
    }, 0);
  }

  

  close(data?){
    this.analyticsService.gtag(this.componentName, 'close');
    this.dialogRef.close(data);
  }
}
